import { Lightning as lng, Router } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';

export class ErrorMessage extends lng.Component {
  static _template() {
    return {
      Overlay: {
        w: w => w,
        h: h => h,
        visible: false,
        Background: {
          w: w => w,
          h: h => h,
          rect: true,
          color: Theme.Colors.Player.Background.Error,
        },
        Message: {
          x: w => w * 0.5,
          y: h => h * 0.5,
          mount: 0.5,
          text: {
            ...Theme.Fonts.Player.Error,
            text: '',
            textAlign: 'center',
          },
        },
      },
    };
  }

  /**
   * @param {string} msg
   */
  setErrorMessage(msg) {
    this.tag('Message').text.text = msg;
    this.tag('Overlay').visible = !!msg;
  }

  /**
   * @param {PlayerController} playerController
   */
  registerEventHandler(playerController) {
    playerController.uiEventHandlers.errorHandler = msg => {
      this.setErrorMessage(msg);
    };
  }

  _handleBack() {
    Router.navigate('main');
  }
}
